import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';

import { IcCloseSvg } from '~/assets/images/icon';
import HideScroll from '~/components/common/hide-scroll';
import Partners from '~/components/home/partners';
import Vision from '~/components/home/vision';
import Footer from '~/components/layout/footer';
import Header from '~/components/layout/header';

Modal.setAppElement('#root');

const Home: React.FC = () => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  useEffect(() => {
    const value = localStorage.getItem('modal');
    if (!value) {
      setModalIsOpen(false);
    }
  }, []);

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };

  const handleCloseModalForever = () => {
    setModalIsOpen(false);

    localStorage.setItem('modal', '1');
  };

  return (
    <>
      <div className="wrap">
        <Header />

        <div className="content">
          <Vision />

          <Partners />
        </div>

        <Footer />
      </div>

      {modalIsOpen && <HideScroll />}

      <Modal
        isOpen={modalIsOpen}
        className="modal"
        overlayClassName="modalBg"
        onRequestClose={handleCloseModal}
      >
        <div className="modalDialog">
          <div className="modalHeader">
            {/* <img src={c2xLogoWhiteSvg} alt="c2x" className="modalLogo" /> */}
            <img
              src={IcCloseSvg}
              className="modalClose"
              alt=""
              onClick={handleCloseModal}
            />
          </div>
          <div className="modalContent xs-txt">
            <p>
              C2X Blockchain Game Platform has been officially launched in
              collaboration with industry-leading partners: Terraform Labs,
              Hashed, and Com2uS Group.
            </p>
            <p>
              C2X is a decentralized platform building technology with the
              purpose of accelerating mass adoption of Web3 gaming. C2X platform
              aims to be a ‘user-participatory platform’ to grow together using
              blockchain technology with ecosystem participants.
            </p>
            <p>
              C2X token, the native token of the platform that was just issued,
              is designed based on the Terra blockchain network as a governance
              token. C2X token will build its own token economy with linked
              services on the platform such as blockchain games and NFT
              marketplace in the future.
            </p>
            <p>
              Starting Q1 2022, more than 10 blockchain games with various
              genres will be released on the C2X platform. Other blockchain
              services such as NFT marketplace and cryptocurrency wallet will
              also be introduced this year.
            </p>
          </div>
        </div>
        <div
          className="modalDontShow xxs-txt"
          onClick={handleCloseModalForever}
        >
          Don't show me agian
        </div>
      </Modal>
    </>
  );
};

export default Home;
